import { useMembersContext } from '@/contexts/membersContext';
import PaginatedResponse from '@/types/paginatedResponse';
import { Substance } from '@/types/substance';
import ajax from '@/utils/ajax';

export interface TreatableSubstanceParams {
  jurisdiction?: string;
}

export const treatableSubstanceRepository = {
  BASE_PATH: '/api/treatable-substances/',

  async list({
    host,
    params
  }: {
    host: string;
    params?: TreatableSubstanceParams;
  }): Promise<PaginatedResponse<Substance[]>> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`,
      params: {
        ...params
      }
    });

    return response.data;
  }
};

export const TreatableSubstanceRepository = () => {
  const { host } = useMembersContext();

  return {
    async list(params: TreatableSubstanceParams) {
      return treatableSubstanceRepository.list({ host, params });
    }
  };
};
